import { onConnect } from '@sonicgarden/onconnect';
import TomSelect from 'tom-select';

onConnect('select.js-tom-select-multiple', (element) => {
  const tomSelect = new TomSelect(element, {
    create: false,
    plugins: ['remove_button'],
  });
  return () => {
    tomSelect.destroy();
  };
});

onConnect('select.js-tom-select-for-tag', (element) => {
  const tomSelect = new TomSelect(element, {
    create: true,
    persist: false,
  });
  return () => {
    tomSelect.destroy();
  };
});

onConnect('select.js-tom-select-for-category', (element) => {
  const tomSelect = new TomSelect(element, {
    create: true,
    persist: false,
    maxItems: 1,
  });
  return () => {
    tomSelect.destroy();
  };
});
